import React from "react";
import logo from "../../resources/logo.png";
import "./Logo.scss";
import classNames from "classnames";
import { withDefaults } from "../../utils/withDefaults";

export interface LogoProps {
  className?: string;
}

export default function Logo(incomingProps: LogoProps) {
  const props = withDefaults(incomingProps, logoDefaultProps);

  return (
    <a href="/" className={classNames("app-logo-link", props.className)}>
      <img src={logo} alt="Dashboi Logo" className="app-logo" />
    </a>
  );
}

const logoDefaultProps = {
  className: ""
};
